module.exports = __webpack_public_path__ + "img/portrait-079.df7ae2d4.jpg";